export const styles = {
  container: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90vw", sm: 430 },
    maxWidth: "90vw",
    maxHeight: "96vh",
    bgcolor: "background.paper",
    border: "2px solid gray",
    borderRadius: 5,
    boxShadow: 24,
    p: 4,
    overflow: { xs: "auto", sm: "visible" },
  },
  title: {
    fontSize: "18px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
};
